// useProjectSwitcher handles project switching logic via API call.

import { useState } from "react";
import { apiClient } from "../../connections/apiClient";
import apiRoutes from "../../connections/apiRoutes";
//import PropTypes from "prop-types";

export default function useProjectSwitcher(
  initialCode,
  authTokens,
  logoutUser,
) {
  const [currentProject, setCurrentProject] = useState(initialCode);
  const [changingProject, setChangingProject] = useState(false);

  const confirmChange = () => {
    const params = {
      implementation_code: currentProject,
      refresh_token: authTokens.refresh,
    };
    setChangingProject(true);
    apiClient
      .post(apiRoutes.accounts_changeproject, params)
      .then((response) => {
        if (response.data.success) {
          logoutUser();
        } else {
          console.error(response.data);
        }
      })
      .catch((error) => console.error(error))
      .finally(() => setChangingProject(false));
  };

  return {
    currentProject,
    changingProject,
    setCurrentProject,
    confirmChange,
  };
}

// No propTypes needed for hooks directly unless wrapping them into components
